<template>
  <div class="login-container">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <form @submit.prevent="login">
            <div class="form-group">
              <img :src="`${publicPath}covidLogo.png`" class="mx-auto d-block mt-5" alt="COVID Learners Logo" />
            </div>

            <div class="form-group mt-5">
              <label for="email" class="text-uppercase">{{ $t('login.email') }}</label>
              <input id="email" type="email" class="form-control" placeholder="sample@address.com" required v-model="params.user.email">
            </div>

            <div class="form-group">
              <label for="password" class="text-uppercase">{{ $t('login.password') }}</label>
              <div class="input-group">
                <input id="password" :type="passwordVisible ? 'text' : 'password'" class="form-control" required v-model="params.user.password" autocomplete="new-password" placeholder="Password">
                <div class="input-group-append" @click="passwordVisible = !passwordVisible">
                  <span class="input-group-text"><font-awesome-icon :icon="passwordVisible ? ['far', 'eye'] : ['far', 'eye-slash']"></font-awesome-icon></span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <button type="submit" class="btn btn-primary btn-block text-uppercase">{{ $t('login.login') }}</button>
            </div>

            <div class="form-group">
              <p class="text-right text-uppercase"><router-link :to="{ name: 'ForgotPassword' }">{{ $t('login.forgotPassword') }}</router-link></p>
              <img :src="`${publicPath}alterisGroupLogo.png`" alt="AlterisGroup Logo" class="float-right mx-auto pt-5" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { saveToken } from '@/services/jwt.service';
import { mapMutations } from 'vuex';
import common from "@/mixins/common";

export default {
  name: 'Login',
  mixins: [common],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      params: {
        user: {
          email: null,
          password: null,
        },
      },
      passwordVisible: false,
    };
  },
  methods: {
    ...mapMutations(['setSessionUuid']),
    login() {
      axios.post('users/sign_in', this.params)
        .then(({ data }) => {
          // store token, set headers and push router to new dashboard page.
          if (data.session_uuid) {
            this.setSessionUuid(data.session_uuid);
          }
          saveToken(data.token);
          this.safelyNavigateToPath('OrganizationSelector');
        })
        .catch((err) => {
          this.log('Login -> Login', 'err', err, false);
          this.errorGrowl("Invalid Email Or Password");
        });
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">
</style>
